export const FIND_HOME_BY_HASH_COMPANY = "FIND_HOME_BY_HASH_COMPANY"
export const FIND_HOME_BY_HASH_COMPANY_SUCCESS = "FIND_HOME_BY_HASH_COMPANY_SUCCESS"

export const FIND_HOME_BY_QUERY_COMPANY = "FIND_HOME_BY_QUERY_COMPANY"
export const FIND_HOME_BY_QUERY_COMPANY_SUCCESS = "FIND_HOME_BY_QUERY_COMPANY_SUCCESS"

export const FIND_HOME_BY_QUERY_COMPANY_API_ERROR = "FIND_HOME_BY_QUERY_COMPANY_API_ERROR"
